import React, { Component } from "react";
import { Router, Route, Switch } from "react-router-dom";
//---Components--//
import Horoscopes from "./mobioastro/components/screens/horoscopes/horoscopes";
import HoroscopeDetail from "./mobioastro/components/screens/horoscrpeDetail/horoscopeDetail";
import AccessDenied from "./mobioastro/components/screens/accessDenied/accessDenied";
import TarotReading from "./mobioastro/components/screens/tarotreading/tarotReading";
import DailyTarot from "./mobioastro/components/screens/tarotreading/dailyTarot";
import Coffeecups from "./mobioastro/components/screens/coffeecupreading/coffeeCups";
import CoffeeReadings from "./mobioastro/components/screens/coffeecupreading/coffeeReadings";
import Login from "./mobioastro/components/screens/login/login";
import AddAccount from "./mobioastro/components/screens/addAccount/addAccount";
import Numerology from "./mobioastro/components/screens/numerology/numerology";
import Game from "./mobioastro/components/screens/games/game";
import FortuneCookie from "./mobioastro/components/screens/games/fortuneCookies";
import DailyLove from "./mobioastro/components/screens/tarotreading/dailyLove";
import TarotReadingLanding from "./mobioastro/components/screens/tarotreading/tarotReadingLanding";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fortawesome/fontawesome-free/js/all.min.js";
//---Tarots---//
import Tarot0 from "./mobioastro/components/screens/tarotCards/tarotCard0";
import Tarot1 from "./mobioastro/components/screens/tarotCards/tarotCard1";
import Tarot2 from "./mobioastro/components/screens/tarotCards/tarotCard2";
import Tarot3 from "./mobioastro/components/screens/tarotCards/tarotCard3";
import Tarot4 from "./mobioastro/components/screens/tarotCards/tarotCard4";
import Tarot5 from "./mobioastro/components/screens/tarotCards/tarotCard5";
import Tarot6 from "./mobioastro/components/screens/tarotCards/tarotCard6";
import Tarot7 from "./mobioastro/components/screens/tarotCards/tarotCard7";
import Tarot8 from "./mobioastro/components/screens/tarotCards/tarotCard8";
import Tarot9 from "./mobioastro/components/screens/tarotCards/tarotCard9";
import Tarot10 from "./mobioastro/components/screens/tarotCards/tarotCard10";
import Tarot11 from "./mobioastro/components/screens/tarotCards/tarotCard11";
import AstroNowHoroscopes from "./checkastronow/components/screens/horoscopes/horoscopes";
import AstroNowHoroscopeDetail from "./checkastronow/components/screens/horoscrpeDetail/horoscopeDetail";
import AstroNowTarotReading from "./checkastronow/components/screens/tarotreading/tarotReading";
import AstroNowDailyTarot from "./checkastronow/components/screens/tarotreading/dailyTarot";
import AstroNowLogin from "./checkastronow/components/screens/login/login";
import AccountPage from "./mobioastro/components/screens/addAccount/addAccount";
import Privateroute from "./utils/privateroute";
import history from "./utils/history";
import { config } from "./utils/domain_config";
import { sendData } from "./analytics/sendData";
import { BASE_URL } from "./utils/constants";
import axios from "axios";
import VideoGallery from "./mobioastro/components/screens/Astrovideos/VideoGallery/VideoGallery";
import VideoPlayer from "./mobioastro/components/screens/Astrovideos/VideoPlayer/VideoPlayer";
import "./App.css";
class App extends Component {
  constructor(props) {
    super(props);

    var url_string = window.location.href;
    var url = new URL(url_string);
    var uid = url.searchParams.get("uid") || url.searchParams.get("UID");
    if (
      !sessionStorage.getItem("loggedIn") ||
      JSON.parse(sessionStorage.getItem("loggedIn")).loggedIn == false
    )
      sessionStorage.setItem("uid", JSON.stringify({ uid: uid }));

    var redirecturl = url.searchParams.get("b");
    this.state = {
      loading: true,
      uid: uid,
      redirecturl: redirecturl,
    };
  }
  componentDidMount() {
    const url = new URL(window.location.href);
    const uid = url.searchParams.get("uid") || url.searchParams.get("rid");
    const msisdn = url.searchParams.get("msisdn");
    const is_staging = url.searchParams.get("is_staging");
    const domain = url.hostname.includes("local")
      ? "uk.mobioastro.com"
      : url.hostname;
    const country = domain.split(".")[0];
    let isloggedIn = {};
    if (sessionStorage.getItem("loggedIn"))
      isloggedIn = JSON.parse(sessionStorage.getItem("loggedIn"));
    if (is_staging && is_staging === "true" && uid) {
      axios
        .post(`${BASE_URL}/checkAccess/staging`, {
          uid: uid,
          domain: domain,
        })
        .then((response) => {
          if (response.data.success) {
            this.checkAccess(response.data);
            sessionStorage.setItem("staging", true);
            this.setState({ loading: false });
            history.push("/");
          } else {
            this.setState({ loading: false });
            history.push("/login");
          }
        })
        .catch((e) => {
          this.setState({ loading: false });
          history.push("/login");
        });
    } else if (uid) {
      axios
        .post(`${BASE_URL}/checkAccess/uid`, {
          uid: uid,
          domain: domain,
        })
        .then((response) => {
          if (response.data.success) {
            this.checkAccess(response.data);
            this.setState({ loading: false });
            history.push("/");
          } else {
            this.setState({ loading: false });
            history.push("/login");
          }
        })
        .catch((e) => {
          this.setState({ loading: false });
          history.push("/login");
        });
    } else if (msisdn) {
      axios
        .post(`${BASE_URL}/checkAccess/msisdn`, {
          msisdn: msisdn,
          domain: domain,
        })
        .then((response) => {
          if (response.data.success) {
            this.checkAccess(response.data);
            this.setState({ loading: false });
            history.push("/");
          } else {
            this.setState({ loading: false });
            history.push("/login");
          }
        })
        .catch((e) => {
          this.setState({ loading: false });
          history.push("/login");
        });
    } else {
      this.setState({ loading: false });
      history.push("/login");
    }
  }

  checkAccess = (data) => {
    sessionStorage.setItem("loggedIn", JSON.stringify({ loggedIn: true }));
    sessionStorage.setItem("rockmanId", data.payload.rockmanId);
    sessionStorage.setItem("start_date", data.payload.start_date);
    sessionStorage.setItem("end_date", data.payload.expiry_date);
    sessionStorage.setItem("msisdn", data.payload.msisdn);
    if (data.payload.token) {
      sessionStorage.setItem(
        "uid",
        JSON.stringify({ uid: data.payload.token })
      );
    } else {
      sessionStorage.setItem(
        "uid",
        JSON.stringify({ uid: data.payload.rockmanId })
      );
    }
    return;
  };
  // componentDidMount() {
  //     var isloggedIn = {};
  //     const msisdn = new URL(window.location.href).searchParams.get('msisdn')
  //     console.log(msisdn)
  //     if (sessionStorage.getItem('loggedIn')) isloggedIn = JSON.parse(sessionStorage.getItem('loggedIn'));
  //     if(this.state.uid == 'fdf098fcc6' || (isloggedIn && isloggedIn.loggedIn == true)) {
  //         sessionStorage.setItem('loggedIn', JSON.stringify({ loggedIn: true }))
  //         this.setState({ loading: false });
  //     }
  //     else if(msisdn && msisdn.length > 0) {
  //         console.log("Calling msidn api")
  //         this.authenticateWithMsisdn(msisdn)
  //     }
  //     else {
  //         console.log('calling API---------------------------------')
  //         this.props.getUserStatus(this.state.uid);
  //         setTimeout(() => this.setState({ loading: false }), 5000);
  //     }
  // }
  // authenticateWithMsisdn(msisdn){
  //     let host = (window.location.host.includes('localhost')) ? 'uk.mobioastro.com' : window.location.hostname
  //     let domain = host.split('.')[0]
  //     if(['bh'].indexOf(domain) >= 0){
  //         axios.get(`https://eu-api.sam-media.com/api/v1/subscription/validate-access-msisdn-domain/sammediacp?msisdn=${msisdn}&domain=${host}`)
  //         .then((response) => {
  //             // this.props.hide();
  //             if (response.data.status === 1) {
  //                 sessionStorage.setItem('loggedIn', JSON.stringify({ loggedIn: true }));
  //                 sessionStorage.setItem('rockmanId', response.data.rockmanId);
  //                 sessionStorage.setItem('start_date', response.data.subscribed_at);
  //                 sessionStorage.setItem('end_date', response.data.next_renewal_date);
  //                 sessionStorage.setItem('msisdn', response.data.msisdn);
  //                 this.setState({loading: false})
  //                 history.push({
  //                     pathname: '/'
  //                 });
  //             }
  //             else {
  //                 this.setState({loading: false})
  //                 history.push({
  //                     pathname: '/accessDenied'
  //                 });
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error);
  //             this.setState({loading: false})
  //             history.push({
  //                 pathname: '/accessDenied'
  //             });
  //         });
  //     }
  //     else if(['uk', 'gr'].indexOf(domain) >= 0){
  //         axios.get(`https://de-mcb-api.sam-media.com/mcb/api/v2/validate-access/sam?msisdn=${msisdn}&domain=${host}`)
  //         .then((response) => {
  //             // this.props.hide();
  //             if (response.data.state === "success") {
  //                 sessionStorage.setItem('loggedIn', JSON.stringify({ loggedIn: true }));
  //                 sessionStorage.setItem('rockmanId', response.data.payload.rockmanId);
  //                 sessionStorage.setItem('start_date', response.data.payload.startDate);
  //                 sessionStorage.setItem('end_date', response.data.payload.renewalDate);
  //                 sessionStorage.setItem('msisdn', response.data.payload.msisdn_full);
  //                 sessionStorage.setItem('uid', JSON.stringify({uid: response.data.payload.token}))
  //                 this.setState({loading: false})
  //                 history.push({
  //                     pathname: '/'
  //                 });
  //             }
  //             else {
  //                 this.setState({loading: false})
  //                 history.push({
  //                     pathname: '/accessDenied'
  //                 });
  //             }
  //         })
  //         .catch((error) => {
  //             console.log(error);
  //             this.setState({loading: false})
  //             history.push({
  //                 pathname: '/accessDenied'
  //             });
  //         });
  //     }
  // }
  // componentWillReceiveProps = (nextprops) => {
  //   let isloggedIn =
  //     (JSON.parse(sessionStorage.getItem("loggedIn")) &&
  //       JSON.parse(sessionStorage.getItem("loggedIn")).loggedIn) ||
  //     false;
  //   if (
  //     nextprops.status === 1 ||
  //     this.state.uid === "fdf098fcc6" ||
  //     isloggedIn == true
  //   ) {
  //     sessionStorage.setItem("loggedIn", JSON.stringify({ loggedIn: true }));
  //   } else {
  //     sessionStorage.setItem("loggedIn", JSON.stringify({ loggedIn: false }));
  //   }
  // };
  render() {
    let countryCode = JSON.parse(sessionStorage.getItem("countryCode"));
    const { loading } = this.state;
    let hostname = window.location.host;
    if (loading) {
      return null;
    }
    return (
      <div
        className={
          hostname.indexOf("checkastro") >= 0
            ? "checkastrnow-App direction-ltr"
            : countryCode.countryCode === "eg" ||
              countryCode.countryCode === "ps" ||
              countryCode.countryCode === "jo"
            ? "App direction-rtl"
            : "App direction-ltr"
        }
      >
        <Router history={history}>
          {hostname.indexOf("checkastro") >= 0 ? (
            <Switch>
              <Privateroute
                exact
                path="/"
                component={AstroNowHoroscopes}
                status={this.props.status}
              />
              <Privateroute
                exact
                path="/horoscopeDetail"
                component={AstroNowHoroscopeDetail}
              />
              <Privateroute
                exact
                path="/tarotreading"
                component={AstroNowTarotReading}
              />
              <Privateroute
                exact
                path="/dailyTarot"
                component={AstroNowDailyTarot}
              />
              <Privateroute exact path="/Coffeecups" component={Coffeecups} />
              <Privateroute
                exact
                path="/CoffeeReadings"
                component={CoffeeReadings}
              />
              <Privateroute path="/fortuneCookie" component={FortuneCookie} />
              <Route path="/accessDenied" component={AccessDenied} />
              <Route path="/login" component={AstroNowLogin} />
              <Privateroute path="/account" component={AddAccount} />
              <Route path="/numerology" component={Numerology} />
              <Route path="/game" component={Game} />
              <Route path="/dailyLove" component={DailyLove} />
              <Route path="/tarotReadingLanding" component={TarotReading} />

              <Route path="/tarot0" component={Tarot0} />
              <Route path="/tarot1" component={Tarot1} />
              <Route path="/tarot2" component={Tarot2} />
              <Route path="/tarot3" component={Tarot3} />

              <Route path="/tarot4" component={Tarot4} />
              <Route path="/tarot5" component={Tarot5} />
              <Route path="/tarot6" component={Tarot6} />
              <Route path="/tarot7" component={Tarot7} />

              <Route path="/tarot8" component={Tarot8} />
              <Route path="/tarot9" component={Tarot9} />
              <Route path="/tarot10" component={Tarot10} />
              <Route path="/tarot11" component={Tarot11} />
              {/* <Route path="/account" component={AccountPage} /> */}
            </Switch>
          ) : (
            <Switch>
              <Privateroute
                exact
                path="/"
                component={Horoscopes}
                status={this.props.status}
              />
              <Privateroute
                exact
                path="/horoscopeDetail"
                component={HoroscopeDetail}
              />
              <Privateroute
                exact
                path="/tarotreading"
                component={TarotReading}
              />
              <Privateroute exact path="/dailyTarot" component={DailyTarot} />
              <Privateroute exact path="/Coffeecups" component={Coffeecups} />
              <Privateroute
                exact
                path="/CoffeeReadings"
                component={CoffeeReadings}
              />
              <Privateroute path="/fortuneCookie" component={FortuneCookie} />
              <Privateroute path="/videos" component={VideoGallery} />
              <Privateroute path="/video-play/:id" component={VideoPlayer} />

              <Privateroute path="/account" component={AddAccount} />
              <Privateroute path="/numerology" component={Numerology} />
              <Route path="/game" component={Game} />
              <Privateroute exact path="/dailyLove" component={DailyLove} />
              <Route
                path="/tarotReadingLanding"
                component={TarotReadingLanding}
              />
              <Privateroute path="/tarot0" component={Tarot0} />
              <Privateroute path="/tarot1" component={Tarot1} />
              <Privateroute path="/tarot2" component={Tarot2} />
              <Privateroute path="/tarot3" component={Tarot3} />
              <Privateroute path="/tarot4" component={Tarot4} />
              <Privateroute path="/tarot5" component={Tarot5} />
              <Privateroute path="/tarot6" component={Tarot6} />
              <Privateroute path="/tarot7" component={Tarot7} />
              <Privateroute path="/tarot8" component={Tarot8} />
              <Privateroute path="/tarot9" component={Tarot9} />
              <Privateroute path="/tarot10" component={Tarot10} />
              <Privateroute path="/tarot11" component={Tarot11} />
              {/* <Privateroute path="/account" component={AccountPage} /> */}
              <Route path="/accessDenied" component={AccessDenied} />
              <Route path="/login" component={Login} />
            </Switch>
          )}
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js